(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[387],{

/***/ "hBQy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Check", function() { return Check; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Check = function Check(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M26.4503752,6.71715276 C26.1079258,6.36495332 25.6163766,6.16176365 25.0996274,6.16176365 C24.5848282,6.16176365 24.093279,6.36301833 23.7508296,6.71521776 L12.2906979,18.444344 L6.26463759,12.3078538 C5.91050316,11.9441044 5.42864393,11.7428047 4.91001976,11.7428047 L4.91001976,11.7428047 C4.39913558,11.7428047 3.90760137,11.9478544 3.55927193,12.3059038 C3.19933251,12.6794032 3.00001282,13.1729024 3.00001282,13.6953516 C3.00001282,14.2197507 3.19933251,14.7151999 3.56314192,15.0925993 L10.9362001,22.6183873 C11.2960495,22.9879867 11.7779988,23.1912363 12.2906979,23.1912363 C12.8015971,23.1912363 13.2796463,22.9899367 13.6376958,22.6222873 L26.4523252,9.4980583 C27.1838741,8.74520951 27.1819241,7.47187655 26.4503752,6.71715276"
  }));
};

/***/ })

}]);